export enum LocaleEnum {
    CSE = 'fr_FR_CSE',
    FR = 'fr_FR',
    NL = 'nl_NL',
    EN = 'en_US'
}
